import CashPaymentForm from "./CashPaymentForm"
import PropTypes from "prop-types"
import CustomDrawer from "ui/Drawer"
import { useBreakpoints } from "modules/window/hooks/useBreakpoints"
import { Modal } from "ui/Modal"

const RecordPaymentModal = ({ onOpen, onClose, remainingBalance, bookingUUID, bookingId }) => {
  const breakpoint = useBreakpoints()
  const isMobile = ["xs", "xsm", "sm", "md"].includes(breakpoint)

  const modalContent = (
    <CashPaymentForm remainingBalance={remainingBalance} bookingUUID={bookingUUID} bookingId={bookingId} onClose={onClose} />
  )

  return isMobile ? (
    <CustomDrawer open={onOpen} setOpen={onClose} title="Record Payment">
      {modalContent}
    </CustomDrawer>
  ) : (
    <Modal centered title="Record Payment" open={onOpen} onCancel={onClose} width={800}>
      {modalContent}
    </Modal>
  )
}

RecordPaymentModal.propTypes = {
  onOpen: PropTypes.bool,
  onClose: PropTypes.func,
  remainingBalance: PropTypes.number,
  bookingUUID: PropTypes.string,
  bookingId: PropTypes.number
}

export default RecordPaymentModal
